module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paco-status"
  }, [_c('div', {
    staticClass: "paco-status__card"
  }, [(_vm.status === 'polling') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__spinner"
  }, [_c('svg', {
    staticClass: "paco-status__spinner-svg",
    attrs: {
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "none",
      "stroke-width": "4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title"
  }, [_vm._v("กำลังตรวจสอบการชำระเงิน")]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__subtitle"
  }, [_vm._v("กรุณารอสักครู่ ระบบกำลังยืนยันการชำระเงินของคุณ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.status === 'confirmed') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__icon paco-status__icon--success"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title paco-status__title--success"
  }, [_vm._v("การบริจาคของคุณสำเร็จแล้ว")]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__subtitle"
  }, [_vm._v(_vm._s(_vm.confirmationMessage))]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__note"
  }, [_vm._v("ระบบจะส่งอีเมลยืนยันพร้อมรายละเอียดให้คุณเร็ว ๆ นี้")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.status === 'timeout') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__icon paco-status__icon--warning"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title paco-status__title--warning"
  }, [_vm._v("ไม่สามารถยืนยันการชำระเงินได้")]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__subtitle"
  }, [_vm._v("ไม่สามารถยืนยันการชำระเงินได้ในขณะนี้ กรุณาตรวจสอบอีเมลของคุณ หรือติดต่อเราเพื่อยืนยันสถานะการบริจาค")]), _vm._v(" "), _c('a', {
    staticClass: "paco-status__btn",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("กลับไปยังหน้าหลัก")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paco-status__progress"
  }, [_c('div', {
    staticClass: "paco-status__progress-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paco-status__redirect"
  }, [_c('span', {
    staticClass: "paco-status__redirect-dot"
  }), _vm._v("\n        กำลังพาคุณไปยังหน้ายืนยัน...\n      ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51e09e38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e09e38","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PacoStatus.vue
// module id = 740
// module chunks = 1